import { useContext, useMemo } from 'react';

import { Flex, Skeleton } from '@frontend/components';
import { useDateFormat } from '@frontend/utils';

import { PopoutContext } from 'modules/notifications/hooks/PopoutContext.js';

import { capitalize } from 'utils/stringUtils';

import NotificationBusinessNameBadge from './NotificationBusinessNameBadge';
import NotificationDate from './NotificationDate';

const NotificationDateAndBusinessName = ({
  isCurrent,
  isFlash = false,
  isLoading = false,
  notification,
  userGroupMembers,
}) => {
  const { isPopout } = useContext(PopoutContext);
  const { generateRelativeDateTime } = useDateFormat();

  const isUserMultipleGroupMember =
    userGroupMembers && userGroupMembers.length > 1 ? true : false;

  const eventTime = notification?.eventTime;

  const relativeDate = useMemo(
    () => eventTime && capitalize(generateRelativeDateTime(eventTime)),
    [generateRelativeDateTime, eventTime],
  );

  const { businessName } = notification.group;

  return (
    <Skeleton isLoaded={!isLoading}>
      <Flex
        flexDirection={isPopout || isFlash ? 'column' : 'row'}
        marginTop={0.5}
      >
        {isUserMultipleGroupMember ? (
          <NotificationBusinessNameBadge
            businessName={businessName}
            isCurrent={isCurrent}
          />
        ) : null}
        {relativeDate && <NotificationDate date={relativeDate} />}
      </Flex>
    </Skeleton>
  );
};

export default NotificationDateAndBusinessName;
